import { Text } from '$components'
import { SendIcon } from '$components'
import { AnimatedOutlet } from '$components'

export function NoInvitationsEmptyState() {
  return (
    <div className="w-full p-stack-hero bg-surface-muted rounded-card flex flex-col items-center justify-center text-center">
      <SendIcon className="size-12 text-fg-link mb-stack-roomy" />

      <Text
        type="h3"
        className="mb-stack-roomy text-fg"
      >
        No outstanding invitations
      </Text>

      <Text
        type="s"
        className="text-fg-subtle max-w-prose-sm"
      >
        When you invite team members to your organisation, they&apos;ll appear here until they accept or the invitation expires.
      </Text>

      <AnimatedOutlet />
    </div>
  )
}
